import { useTheme, type ThemeChoice } from "../lib/theme";

const CHOICES: { value: ThemeChoice; label: string; icon: string }[] = [
  { value: "light", label: "Light", icon: "M12 4V2.5M12 21.5V20M4 12H2.5M21.5 12H20M6.3 6.3 5.2 5.2M18.8 18.8l-1.1-1.1M6.3 17.7l-1.1 1.1M18.8 5.2l-1.1 1.1M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z" },
  { value: "dark", label: "Dark", icon: "M19.5 14.6A8 8 0 0 1 9.4 4.5a8 8 0 1 0 10.1 10.1Z" },
  { value: "system", label: "Same as the device", icon: "M3.5 5.5h17v11h-17zM9 20h6M12 16.5V20" },
];

/** Light, dark, or the device's own setting, for the panels' top bars. */
export function ThemeSwitch({ className }: { className?: string }) {
  const [choice, setChoice] = useTheme();
  return (
    <div className={["theme-switch", className].filter(Boolean).join(" ")} role="group" aria-label="Colour theme">
      {CHOICES.map((c) => (
        <button key={c.value} type="button" aria-pressed={choice === c.value} aria-label={c.label} title={c.label} onClick={() => setChoice(c.value)}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d={c.icon} />
          </svg>
        </button>
      ))}
    </div>
  );
}
